<template>
  <!-- 对齐 App login.dart：登录方式选择页（LOGO 弹性居中 + E-mail/Phone 按钮 + 第三方登录） -->
  <div class="login-warp">
    <div class="login-top"></div>
    <div class="logo">
      <img src="../../assets/imgs/img_logo.png" alt="" />
    </div>
    <div class="login-mid"></div>
    <div class="login-btns">
      <div class="login-type-btn email" @click="onEmail">
        <img src="../../assets/imgs/icon_email.png" alt="" />
        <span>{{ i18n.login_with_email }}</span>
      </div>
      <div class="login-type-btn phone" @click="onPhone">
        <img src="../../assets/imgs/icon_iphone.png" alt="" />
        <span>{{ i18n.login_with_phone }}</span>
      </div>
      <div class="login-foot">
        <div class="login-foot-tips">
          <span>{{ i18n.sign_in_with }}</span>
        </div>
        <div class="login-foot-imgs">
          <!-- 隐藏 Apple 登录入口（代码保留，需要时恢复） -->
          <!-- <login-apple @success="loadUser">
            <img src="../../assets/imgs/icon_apple_login.png" alt="" />
          </login-apple> -->
          <login-google @success="loadUser"></login-google>
        </div>
      </div>
      <div class="login-foot-gap"></div>
    </div>
  </div>
</template>

<script>
import { USER_INFO } from "../../apis/user"
// 隐藏 Apple 登录：移除 LoginApple 引用（需要时恢复）
import { LoginGoogle } from "../../components/login"
import { mapState } from "vuex"
export default {
  components: {
    LoginGoogle
  },
  computed: {
    ...mapState(["user", "browser"]),
    i18n() {
      return this.$t("login")
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.$router.push("/")
      }
    }
  },
  methods: {
    onEmail() {
      this.$router.push("/login_email")
    },
    onPhone() {
      this.$router.push("/login_phone")
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    }
  },
  created() {
    if (this.browser === "wechat") {
      this.$router.push("/login_wechat")
    } else if (this.browser === "alipay") {
      this.$router.push("/login_alipay")
    }
  }
}
</script>

<style lang="less">
.login-warp {
  height: 100vh;
  display: flex;
  flex-direction: column;

  // 对齐 App：LOGO 上下 Expanded 弹性居中
  .login-top,
  .login-mid {
    flex: 1;
  }

  .logo {
    img {
      display: block;
      margin: 0 auto;
      // 对齐 App：logo 宽 272.w
      width: 476px;
    }
  }

  .login-btns {
    padding: 0 56px;

    // 对齐 App：按钮高 60.w、圆角 14.w、图标 38.w、文字 18.sp Montserrat-M
    .login-type-btn {
      display: flex;
      align-items: center;
      height: 105px;
      border-radius: 24px;
      padding: 0 35px 0 18px;
      margin-bottom: 35px;

      img {
        width: 66px;
        height: 66px;
      }

      span {
        flex: 1;
        text-align: center;
        font-size: 31px;
        font-family: @font-medium;
      }

      &.email {
        background: var(--theme-color);

        span {
          color: var(--text-white);
        }
      }

      &.phone {
        background: var(--item-bg);

        span {
          color: var(--text-main);
        }
      }
    }
  }

  .login-foot {
    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        z-index: 999;
        // 对齐 App login_other：分割文字 color_fillColor(#000)
        color: var(--text-main);
        font-size: 28px;
        padding: 28px;
      }

      &::after {
        content: " ";
        height: 1px;
        width: 30%;
        // 对齐 App login_other：分割线 color_fillColor(#000)
        background-color: var(--text-main);
        z-index: 99;
      }

      &::before {
        content: " ";
        height: 1px;
        width: 30%;
        background-color: var(--text-main);
        z-index: 99;
      }
    }

    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;

      img {
        // 不限制图标尺寸，原始图片大小显示
        max-width: 60px;
        height: auto;
      }
    }

    // 对齐 App：底部留白 32.w
    &-gap {
      height: 56px;
    }
  }
}
</style>
